// var base64 = (content)=> {
//   return window.btoa(unescape(encodeURIComponent(content)));
// }

export default function toExcel(tableID, previewId, Vm, noPreviewClassName) {
  // let cssStr = ''
  // var styles = document.querySelectorAll('style,link');
  var inputs = document.querySelectorAll("input");
  // 获取样式表
  // for (var i = 0; i < styles.length; i++) {
  //   cssStr += styles[i].outerHTML;
  // }
  // 设置 input标签 的 value 属性
  for (var k = 0; k < inputs.length; k++) {
    if (inputs[k].type == "checkbox" || inputs[k].type == "radio") {
      if (inputs[k].checked == true) {
        inputs[k].setAttribute("checked", "checked");
      } else {
        inputs[k].removeAttribute("checked");
      }
    } else if (inputs[k].type == "text") {
      // setAttribute('value', 124) 改变了 input 在 html 中的源代码
      // getElementByID('**').value = 124 并没有改变 input 在html中的源代码，改变的只是文档对象模型 DOM
      inputs[k].setAttribute("value", inputs[k].value);
    } else {
      inputs[k].setAttribute("value", inputs[k].value);
    }
  }
  Vm.previewDialog = true;
  // 在DOM更新后进行，防止获取到 null 值
  Vm.$nextTick(() => {
    document.getElementById(previewId).innerHTML = document.getElementById(
      tableID
    ).outerHTML;
    let inputs = document.getElementById(previewId).querySelectorAll("input");
    // 清除不需要预览的元素
    let noPreviews = document
      .getElementById(previewId)
      .querySelectorAll(`.${noPreviewClassName}`);
    for (var i = 0; i < noPreviews.length; i++) {
      noPreviews[i].outerHTML = null;
    }
    for (var k = 0; k < inputs.length; k++) {
      inputs[k].outerHTML = inputs[k].getAttribute("value");
    }
  });
}
